import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md },
} = constants.breakpoints;

export const dropdownCss = {
  width: "136px",
};

export const buttonCss = (isLevelSelectorVisible: boolean) => {
  if (isLevelSelectorVisible) return {};

  return {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: 0,

    [mediaQuery.upTo(md)]: {
      height: "32px",
    },
  };
};

export const languageInitials = {
  [mediaQuery.downTo(md)]: {
    display: "none",
  },
};

export const languageTitle = {
  [mediaQuery.upTo(md)]: {
    display: "none",
  },
};
